import { Text } from '#core/components';

import styles from './SectionHeader.module.css';

type SectionHeaderProps = {
  children: React.ReactNode;
};

export const SectionHeader = ({ children }: SectionHeaderProps) => {
  return <Text className={styles.root}>{children}</Text>;
};
